"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaCoinToJSON = exports.RosettaCoinFromJSONTyped = exports.RosettaCoinFromJSON = void 0;
const _1 = require("./");
function RosettaCoinFromJSON(json) {
    return RosettaCoinFromJSONTyped(json, false);
}
exports.RosettaCoinFromJSON = RosettaCoinFromJSON;
function RosettaCoinFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'coin_identifier': _1.RosettaAccountBalanceResponseCoinIdentifierFromJSON(json['coin_identifier']),
        'amount': _1.RosettaAmountFromJSON(json['amount']),
    };
}
exports.RosettaCoinFromJSONTyped = RosettaCoinFromJSONTyped;
function RosettaCoinToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'coin_identifier': _1.RosettaAccountBalanceResponseCoinIdentifierToJSON(value.coin_identifier),
        'amount': _1.RosettaAmountToJSON(value.amount),
    };
}
exports.RosettaCoinToJSON = RosettaCoinToJSON;
//# sourceMappingURL=RosettaCoin.js.map